module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-10.4eb49edb.mp3";